/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Nogamesdescription2Inputs */

const id_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya game yang diluncurkan dengan pencapaian yang muncul di pustaka ini.`)
};

const ms_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya permainan yang dilancarkan dengan pencapaian muncul dalam perpustakaan ini.`)
};

const da_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun udgivne spil med achievements vises i dette bibliotek.`)
};

const de_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur veröffentlichte Spiele mit Errungenschaften erscheinen in dieser Bibliothek.`)
};

const en_us2_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only launched games with achievements appear in this library.`)
};

const es_es2_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo los juegos lanzados con logros aparecen en esta biblioteca.`)
};

const es_mx2_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo los juegos lanzados con logros aparecen en esta biblioteca.`)
};

const fil_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga nailabas na laro na may achievement lamang ang lumalabas sa library na ito.`)
};

const fr_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuls les jeux lancés avec des succès apparaissent dans cette bibliothèque.`)
};

const it_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo i giochi pubblicati con risultati appaiono in questa libreria.`)
};

const hu_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csak a teljesítménnyel rendelkező kiadott játékok jelennek meg ebben a könyvtárban.`)
};

const nl_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen uitgebrachte games met prestaties verschijnen in deze bibliotheek.`)
};

const no_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bare utgitte spill med prestasjoner vises i dette biblioteket.`)
};

const pl_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko uruchomione gry z osiągnięciami pojawiają się w tej bibliotece.`)
};

const pt_br2_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas jogos lançados com conquistas aparecem nesta biblioteca.`)
};

const pt_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apenas jogos lançados com conquistas aparecem nesta biblioteca.`)
};

const ro_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar jocurile lansate cu realizări apar în această bibliotecă.`)
};

const fi_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vain julkaistut pelit, joissa on saavutuksia, näkyvät tässä kirjastossa.`)
};

const sv_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endast lanserade spel med prestationer visas i detta bibliotek.`)
};

const vi_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ các game đã phát hành có thành tích mới xuất hiện trong thư viện này.`)
};

const tr_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kütüphanede yalnızca başarımları olan yayınlanmış oyunlar görünür.`)
};

const cs_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V této knihovně se zobrazují pouze vydané hry s úspěchy.`)
};

const bg_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Само пуснати игри с постижения се показват в тази библиотека.`)
};

const ru_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этой библиотеке отображаются только выпущенные игры с достижениями.`)
};

const uk_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У цій бібліотеці відображаються лише випущені ігри з досягненнями.`)
};

const ar_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فقط الألعاب التي تم إصدارها مع إنجازات تظهر في هذه المكتبة.`)
};

const hi_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल लॉन्च किए गए गेम जिनमें उपलब्धियाँ हैं, इस लाइब्रेरी में दिखाई देते हैं।`)
};

const th_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เฉพาะเกมที่วางจำหน่ายแล้วที่มีความสำเร็จเท่านั้นที่แสดงในคลังเกมนี้`)
};

const ja_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績があるリリース済みゲームのみがこのライブラリに表示されます。`)
};

const zh_cn2_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有已运行且有成就的游戏才会显示在此游戏库中。`)
};

const zh_hant1_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只有已執行且有成就的遊戲才會顯示在此遊戲庫中。`)
};

const ko_profile_library_nogamesdescription2 = /** @type {(inputs: Profile_Library_Nogamesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제가 있는 출시된 게임만 이 라이브러리에 표시됩니다.`)
};

/**
* | output |
* | --- |
* | "Only launched games with achievements appear in this library." |
*
* @param {Profile_Library_Nogamesdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_nogamesdescription2 = /** @type {((inputs?: Profile_Library_Nogamesdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Nogamesdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_nogamesdescription2(inputs)
	if (locale === "ms") return ms_profile_library_nogamesdescription2(inputs)
	if (locale === "da") return da_profile_library_nogamesdescription2(inputs)
	if (locale === "de") return de_profile_library_nogamesdescription2(inputs)
	if (locale === "en-US") return en_us2_profile_library_nogamesdescription2(inputs)
	if (locale === "es-ES") return es_es2_profile_library_nogamesdescription2(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_nogamesdescription2(inputs)
	if (locale === "fil") return fil_profile_library_nogamesdescription2(inputs)
	if (locale === "fr") return fr_profile_library_nogamesdescription2(inputs)
	if (locale === "it") return it_profile_library_nogamesdescription2(inputs)
	if (locale === "hu") return hu_profile_library_nogamesdescription2(inputs)
	if (locale === "nl") return nl_profile_library_nogamesdescription2(inputs)
	if (locale === "no") return no_profile_library_nogamesdescription2(inputs)
	if (locale === "pl") return pl_profile_library_nogamesdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_nogamesdescription2(inputs)
	if (locale === "pt") return pt_profile_library_nogamesdescription2(inputs)
	if (locale === "ro") return ro_profile_library_nogamesdescription2(inputs)
	if (locale === "fi") return fi_profile_library_nogamesdescription2(inputs)
	if (locale === "sv") return sv_profile_library_nogamesdescription2(inputs)
	if (locale === "vi") return vi_profile_library_nogamesdescription2(inputs)
	if (locale === "tr") return tr_profile_library_nogamesdescription2(inputs)
	if (locale === "cs") return cs_profile_library_nogamesdescription2(inputs)
	if (locale === "bg") return bg_profile_library_nogamesdescription2(inputs)
	if (locale === "ru") return ru_profile_library_nogamesdescription2(inputs)
	if (locale === "uk") return uk_profile_library_nogamesdescription2(inputs)
	if (locale === "ar") return ar_profile_library_nogamesdescription2(inputs)
	if (locale === "hi") return hi_profile_library_nogamesdescription2(inputs)
	if (locale === "th") return th_profile_library_nogamesdescription2(inputs)
	if (locale === "ja") return ja_profile_library_nogamesdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_nogamesdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_nogamesdescription2(inputs)
	return ko_profile_library_nogamesdescription2(inputs)
});
export { profile_library_nogamesdescription2 as "profile.library.noGamesDescription" }